const ApiConstants = {
    REACT_APP_FRONTEND_URL : "https://tatapower.ems.ingroenergy.com/",
    // REACT_APP_FRONTEND_URL : "http://localhost:3000/",

    REACT_APP_POSTEND_URL : ".html",
    // REACT_APP_POSTEND_URL : "",
    
    HOME_LINK : "https://tatapower.ems.ingroenergy.com/"
    // HOME_LINK : "/"
}

export default ApiConstants;